import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_item = _resolveComponent("menu-item", true)!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.children)
      ? (_openBlock(), _createBlock(_component_q_expansion_item, {
          key: 0,
          "content-inset-level": 1,
          "expand-separator": "",
          icon: _ctx.item.icon,
          label: _ctx.item.label
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              dense: "",
              padding: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child, index) => {
                  return (_openBlock(), _createBlock(_component_menu_item, {
                    item: child,
                    key: 'menu-item'+index
                  }, null, 8, ["item"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["icon", "label"]))
      : _createCommentVNode("", true),
    (!_ctx.item.children || _ctx.item.children.length === 0)
      ? (_openBlock(), _createBlock(_component_q_item, {
          key: 1,
          clickable: "",
          to: _ctx.item.to,
          class: _normalizeClass({ 'q-item--active' : _ctx.route.path.startsWith(_ctx.item.path) })
        }, {
          default: _withCtx(() => [
            (_ctx.item.icon)
              ? (_openBlock(), _createBlock(_component_q_item_section, {
                  key: 0,
                  avatar: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: _ctx.item.icon
                    }, null, 8, ["name"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to", "class"]))
      : _createCommentVNode("", true)
  ], 64))
}